import { t } from '../../../locales';

const invoicesModuleRoutes = {
	path: 'invoices',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: 'order-invoice-details/:id',
			props: true,
			component: () => import('./pages/order-invoice-details/index.vue'),
			meta: {
				title: t('invoices.transaction-details'),
			},
		},
	],
};

export { invoicesModuleRoutes };
